import Aos from "aos";
import { useEffect } from "react";
import "swiper/css";
import "swiper/css/pagination";
import { Mousewheel, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import { useContextHook } from "../Context/ContextOPen";
import { Navbar } from "../layout";
import AboutUs from "./Home/AboutUs";
import ContactUs from "./Home/ContactUs";
import Hero from "./Home/Hero";
import Products from "./Home/Products";
import Services from "./Home/Services";
import "./Home/style.css";
import Partners from "./Home/Partners";

export default function Home() {
  const { setSwiperIndex } = useContextHook();
  const SwiperSlideData = [
    { name: Hero, id: 0 },
    { name: AboutUs, id: 1 },
    { name: Products, id: 2 },
    { name: Services, id: 3 },
    { name: Partners, id: 4 },
    { name: ContactUs, id: 5 },
  ];
  useEffect(() => {
    Aos.init();
  }, [setSwiperIndex]);
  return (
    <>
      <div className="h-[100vh]">
        <div className="fixed top-0 left-0 right-0 z-50">
          <Navbar />
        </div>

        <Swiper
          zoom
          direction="vertical"
          speed={1000}
          slidesPerView={1}
          spaceBetween={10}
          mousewheel={true}
          modules={[Mousewheel, Pagination]}
          onSlideChange={(swiper) => setSwiperIndex(swiper.activeIndex)}
        >
          {SwiperSlideData.map((e, index) => (
            <SwiperSlide id={e.name} key={index} className="overflow-hidden">
              <e.name />
            </SwiperSlide>
          ))}
          <SlideNextButton />
        </Swiper>
      </div>
    </>
  );
}
const SlideNextButton = ({ index }) => {
  const { swiperIndex } = useContextHook();
  const swiper = useSwiper();
  useEffect(() => {
    if (swiperIndex || swiperIndex === 0) {
      swiper?.slideTo(swiperIndex);
    }
  }, [swiperIndex]);

  return <div className="icons "></div>;
};
